<template>
  <v-dialog v-model="isOpen" dark max-width="810px" max-height="400px">
    <v-card>
      <v-card-title>
        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 flush-left">
          <h5>{{title}}</h5>
          <p class="intro-text" v-html="intro"></p>
          <p v-if="sb" class="sb-text">To choose Saddle Blanket, exit this dialog and choose an insert fabric only.</p>
          <p v-if="exoticMessage" class="sb-text">Our Croc, Ostrich, and Carbon Fiber fabrics are made of vinyl, not real animal skin or carbon fiber.</p>
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 flush-left">
          <v-select
            :items="Object.values(categories)"
            item-text="description"
            item-value="productCode"
            label="Filter Fabric Types"
            v-model="filter"
            clearable
            width
            solo
            multiple
            chips
          ></v-select>
        </v-col>
      </v-card-title>
      <v-row>
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel class="info-panel">
              <v-expansion-panel-header><strong>Click here for Fabric Pricing Information</strong></v-expansion-panel-header>
              <v-expansion-panel-content>
                Fabric selection and seat style determines seat cover price. If two fabrics with different prices are chosen, the more expensive fabric determines the price. Fabric pricing below:
                <br><br>
                <strong>Exotics</strong><br>
                $415.95 (most seats) or $535.95 (40/20/40 seats)
                <br><br>
                <strong>Perforated Sof-Touch (if used as insert)</strong><br>
                $382.95 (most seats) or $494.95 (40/20/40 seats)
                <br><br>
                <strong>Tuff Suede, Sof-Touch, Camo or Carbon Fiber</strong><br>
                $341.95 (most seats) or $455.95 (40/20/40 seats)
                <br><br>
                <strong>Velour, Tweed or Dura EZ Care</strong><br>
                $324.95 (most seats) or $424.95 (40/20/40 seats)
                <br><br>
                <strong>Saddle Blanket</strong><br>
                $171.95 (most seats) or $253.95 (40/20/40 seats)<br>
                Accessories come in color-matched vinyl
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-card-text>
        <section v-for="(category, cat) in filtered" :key="cat">
          <h6>{{category.description}}</h6>
          <p class="text-body-1">{{getDescription(cat)}}</p>
          <div class="d-flex flex-wrap justify-start">
            <v-card
              v-for="color in getColors(category)"
              :key="color.colorId"
              width="220"
              class="swatch"
              style="cursor: pointer"
              @click="setColor(color)"
              flat
            >
            <v-img
              lazy-src="https://placehold.co/220x220"
              height="220"
              :src="getTile(color)"
              :alt="color.color"
            />
            <v-card-text class="text-center">
              {{color.color}}
            </v-card-text>
          </v-card>
        </div>
      </section>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<style scoped lang="scss">
.theme--dark.v-card {
  background-color: #353534 !important;
}
.v-card__title {
  display: flex;
  align-items: flex-start;
}
.flush-left {
  padding-left: 0;
}
.swatch {
  margin: 5px 20px 0 0;
}
h5 {
  font-size: 20px;
  color: $white;
  text-transform: uppercase;
  font-weight: 700;
  margin: 0;
  font-family: $body-font-family;

  @media screen and (min-width: 600px) {
    font-size: 28px;
  }
}
h6 {
  font-size: 22px;
  font-weight: 700;
  color: $white;
  font-family: $body-font-family;
  margin: 0 0 10px;
}
p {
  padding-left: 0;
  padding-right: 0;
  word-break: keep-all;

  &.intro-text {
    font-size: 14px;
    line-height: 20px;
  }

  &.sb-text {
    font-size: 14px;
    line-height: 20px;
  }
}
.info-panel {
  background-color: transparent !important;

  &::before {
    box-shadow: none !important;
  }
}
</style>

<script>
import { getTile, getDescription } from '@/services/assets'

export default {
  data() {
    return {
      isOpen: false,
      filter: []
    }
  },
  computed: {
    filtered: function() {
      return this.filter.length
      ? this.filterBy()
      : this.categories
    }
  },
  props: {
    title: String,
    intro: String,
    categories: Array,
    sb: Boolean,
    exoticMessage: Boolean,
    isUtv: Boolean
  },
  methods: {
    getTile: getTile,
    getDescription: getDescription,
    open() {
      this.isOpen = true
    },
    filterBy() {
      return this.categories
        .filter(category => this.filter.includes(category.productCode))
    },
    setColor(color) {
      this.$emit('set-color', color)
      this.isOpen = false
    },
    getColors(category) {
      if (!this.isUtv) {
        return category.colors
      }

      return category.colors.filter(color => {
        const utvFlag = color.colorUtv ?? color.insertColorUtv
        return utvFlag !== false
      })
    },
  }
}
</script>
